<hpf-text-translated-form
        *ngIf="textTranslated"
        [textTranslated]="textTranslated"
        (create)="onCreate($event)"
    ></hpf-text-translated-form>
<div *ngIf="!textTranslated" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>